export default "__VITE_ASSET__CPjRumey__"